export const messages = {
  en: {
    paymentPool: {
      queryCondition: 'Query Conditions',
      selectName: 'Please select name',
      selectPaymentVendor: 'Please select payment vendor',
      selectStatus: 'Please select status',
      query: 'Query',
      paymentConfig: 'Payment Configuration',
      add: 'Add',
      name: 'Name',
      paymentVendor: 'Payment Vendor',
      paymentScope: 'Payment Scope',
      status: 'Status',
      createTime: 'Create Time',
      usageInstructions: 'Usage Instructions',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      communityFee: 'Community Fee',
      tempCarFee: 'Temporary Car Fee',
      specifiedFee: 'Specified Fee',
      enable: 'Enable',
      disable: 'Disable',
      requiredName: 'Required, please enter name',
      requiredPaymentVendor: 'Required, please select payment vendor',
      merchantCert: 'Merchant Certificate (.p12)',
      requiredPaymentScope: 'Required, please select payment scope',
      optionalInstructions: 'Optional, please enter usage instructions',
      save: 'Save',
      cancel: 'Cancel',
      confirmOperation: 'Please confirm your operation',
      confirmDeletePaymentConfig: 'Confirm to delete payment configuration',
      cancelAction: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed',
      uploadFile: 'Upload File',
      fileSizeLimit: 'File size cannot exceed 20MB',
      uploadSuccess: 'File uploaded successfully',
      uploadFailed: 'File upload failed',
      saveSuccess: 'Save successfully'
    }
  },
  zh: {
    paymentPool: {
      queryCondition: '查询条件',
      selectName: '请选择名称',
      selectPaymentVendor: '请选择支付厂家',
      selectStatus: '请选择状态',
      query: '查询',
      paymentConfig: '支付配置',
      add: '添加',
      name: '名称',
      paymentVendor: '支付厂家',
      paymentScope: '支付范围',
      status: '状态',
      createTime: '创建时间',
      usageInstructions: '使用说明',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      communityFee: '小区费用',
      tempCarFee: '临时车费用',
      specifiedFee: '指定费用项',
      enable: '启用',
      disable: '停用',
      requiredName: '必填，请填写名称',
      requiredPaymentVendor: '必填，请选择支付厂家',
      merchantCert: '商户证书(.p12)',
      requiredPaymentScope: '必填，请选择支付范围',
      optionalInstructions: '选填，请填写使用说明',
      save: '保存',
      cancel: '取消',
      confirmOperation: '请确认您的操作',
      confirmDeletePaymentConfig: '确定删除支付配置',
      cancelAction: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      uploadFile: '上传附件',
      fileSizeLimit: '文件大小不能超过20MB',
      uploadSuccess: '文件上传成功',
      uploadFailed: '文件上传失败',
      saveSuccess: '保存成功'
    }
  }
}